<template>
	<div class="about">
		<div style="width: 100vw; height: 80px"></div>
		<div class="top_header">
			<img src="../../assets/images/about_header.png" alt="" />
		</div>
		<div class="about_one">
			<div class="header wow animate__slideInDown animate__animated">
				<img src="../../assets/images/titlee.png" alt="" />
				<div class="title">公司应用</div>
				<div class="blueline"></div>
			</div>
			<div class="content_box">
				<div class="content_one wow animate__fadeInLeft animate__animated">
					<img src="../../assets/images/appview.png" alt="" />
				</div>
				<div class="content_two">
					<div class="title">JJ20 APP</div>
					<div class="dis">
						JJ20是一款集资讯、交友、演唱会追踪、网上商城等功能为一体的软件，满足JM与JJ的零距离交流互动，并致力于为JM打造温馨大家庭。
					</div>
					<div class="downloadbox">
						<div
							class="downloadright wow animate__fadeInUp animate__animated"
							data-wow-delay="0.2s"
						>
							<img src="../../assets/images/app_code.png" alt="" />
						</div>
						<div class="downloadleft">
							<div
								class="downloadleft_box wow animate__fadeInRight animate__animated"
								@click="openUrl('1')"
								data-wow-delay="0.1s"
								style="margin-top: 0px"
							>
								IOS下载
							</div>
							<div
								class="downloadleft_box wow animate__fadeInRight animate__animated"
								@click="openUrl('2')"
								data-wow-delay="0.2s"
							>
								GOOGLE PLAY下载
							</div>
							<div
								class="downloadleft_box wow animate__fadeInRight animate__animated"
								@click="openUrl('3')"
								data-wow-delay="0.3s"
							>
								Android下载
							</div>
						</div>
					</div>
				</div>
				<div class="borderWhitebox"></div>
			</div>
			<div class="backgroundI">
				<img src="../../assets/images/bbr.png" alt="" />
			</div>
		</div>
		<div class="about_two">
			<div class="header wow animate__slideInDown animate__animated">
				<img src="../../assets/images/about_company.png" alt="" />
				<div class="title">公司介绍</div>
				<div class="blueline"></div>
			</div>
			<div class="box_content wow animate__zoomIn animate__animated">
				<img src="../../assets/images/about_one.png" alt="" class="box_img" />
				<div class="content_box">
					<div class="box">
						<div class="titleU">“</div>
						<div class="title">公司自成立以来，一直稳定地为国内、国际知名品牌公司服务</div>
						<div class="titleU" style="text-align: right">”</div>
						<div class="linebox">
							<div class="blue"></div>
							<div class="grey"></div>
						</div>
						<div class="title2">
							我司主要从事数码科技、电子科技、信息科技、
							计算机科技、网络科技领域内的技术开发、技术转让、技术咨询、技术服务。
						</div>
						<div class="title2">
							文化艺术交流策划(演出经纪、营业性演出除外),
							商务信息咨询,企业形象策划,市场营销策划,会务及展览展示活动
							(主办、承办除外),多媒体及动漫制作,图文设计制作。
						</div>
					</div>
				</div>
			</div>
			<img src="../../assets/images/bgrright.png" alt="" class="imgR" />
			<img src="../../assets/images/bgrleft.png" alt="" class="imgL" />
		</div>
		<div class="about_three">
			<div class="header wow animate__slideInDown animate__animated">
				<img src="../../assets/images/about_philo.png" alt="" style="margin-top: 38px" />
				<div class="title">公司理念</div>
				<div class="blueline"></div>
			</div>
			<div class="three_title">我们秉承诚信、创新、负责、高效、不断超越的发展理念，</div>
			<div class="three_title">坚持为客户创造价值，增强市场竞争力，与合作伙伴共同成长。</div>
			<div class="three_row">
				<div class="three_box">
					<div class="three_box_item wow animate__fadeIn animate__animated" data-wow-delay="0.5s">
						<img src="../../assets/images/philo_one.png" alt="" />
					</div>
					<div
						class="three_box_item two wow animate__fadeIn animate__animated"
						data-wow-delay="0.5s"
					>
						<img src="../../assets/images/philo_two.png" alt="" />
					</div>
					<div
						class="three_box_item three wow animate__fadeIn animate__animated"
						data-wow-delay="0.5s"
					>
						<img src="../../assets/images/philo_three.png" alt="" />
					</div>
					<img
						src="../../assets/images/philo_back.png"
						alt=""
						class="bki wow animate__zoomIn animate__animated"
					/>
				</div>
			</div>
		</div>
		<div style="height: 9px; background: white"></div>
		<RequireMent />
	</div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import WOW from "wow.js";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
const wowjsFn = () => {
	let wow = new WOW({
		boxClass: "wow", // default
		animateClass: "animate__animated", // default
		offset: 0, // default
		mobile: true, // default
		live: true, // default
		effect: "fade",
	});
	wow.init();
};
const effect = ref("slide");
let swpierRef = "";
const onSwiper = (swiper) => {
	console.log(swiper);
	swpierRef = swiper;
};
const left = () => {
	swpierRef.slidePrev();
};
const right = () => {
	swpierRef.params.effect = "fade";
	swpierRef.update();
	swpierRef.slideNext();
};
const onSlideChange = () => {};

const autoplayOptions = {
	delay: 2000,
	loop: true,
	disableOnInteraction: false, // 是否在用户交互时停止自动播放
};
const modules = [Autoplay, EffectFade, Pagination];
const openUrl = (code) => {
	if (code == "1") {
		window.open("https://apps.apple.com/us/app/jj20/id1334508518");
	} else if (code == "2") {
		window.open("https://play.google.com/store/apps/details?id=com.jfjsanctuary.start&pli=1");
	} else if (code == "3") {
		window.open("https://oss.jj20-official.com/version/update.html");
	}
};
onMounted(() => {
	wowjsFn();
});
</script>

<style lang="less" scoped>
.about {
	overflow-x: hidden;
	.top_header {
		width: 100vw;
		height: 240px;
		background-image: url("../../assets/images/bnnderBG.png");
		background-repeat: no-repeat;
		background-size: cover;
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			width: 1100px;
			height: 240px;
		}
	}

	.about_two {
		width: 100vw;
		display: flex;
		flex-direction: column;
		align-items: center;
		position: relative;
		.box_content {
			max-width: 1210px;
			height: 500px;
			position: relative;
			z-index: 2;
			.box_img {
				position: absolute;
				z-index: -1;
				min-height: 500px;
			}
			.content_box {
				width: 100%;
				height: 85%;
				z-index: 10;
				display: flex;
				justify-content: center;
				align-items: center;
				.box {
					width: 66%;
					.linebox {
						width: 100%;
						display: flex;
						flex-direction: column;
						align-items: center;
						margin-bottom: 30px;
					}
				}
				.titleU {
					font-family: SimHei;
					color: rgba(18, 177, 249, 1);
					font-size: clamp(26px, 4vw, 48px);
					font-weight: bold;
				}
				.title {
					color: rgba(18, 177, 249, 1);
					font-size: clamp(14px, 2vw, 26px);
					font-weight: bold;
					text-align: center;
				}
				.title2 {
					color: #58687b;
					font-size: clamp(12px, 1.5vw, 20px);
					text-align: center;
					font-weight: bold;
				}
				.blue {
					height: 6px;
					width: 64px;
					background: #12b1f9;
				}
				.grey {
					height: 1px;
					width: 298px;
					background: rgba(203, 228, 241, 1);
				}
			}
			img {
				width: 100%;
			}
		}
		.imgR {
			position: absolute;
			right: 0px;
			top: 0px;
			z-index: 1;
		}
		.imgL {
			position: absolute;
			bottom: 22px;
			left: 0px;
			z-index: 1;
		}
	}
	.about_three {
		width: 100vw;
		background-color: rgb(238, 246, 250);
		.three_title {
			font-size: 18px;
			font-weight: bold;
			color: #58687b;
			text-align: center;
			padding: 0px 10px;
		}
		.three_row {
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.three_box {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			// background-image: url("../../assets/images/philo_back.png");
			// background-repeat: no-repeat;
			// background-size: contain;
			max-width: 1192px;
			position: relative;
			.three_box_item {
				z-index: 2;
			}
			.bki {
				position: absolute;
				width: 100%;
				object-fit: contain;
				z-index: 1;
			}
		}
	}
	.header {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 20px;
		color: #102d4d;
		letter-spacing: 1.5px;
		font-weight: bold;
		position: relative;
		img {
			margin-top: 21px;
			transform: scale(0.75);
		}
		.title {
			margin-top: -20px;
		}
		.blueline {
			width: 44px;
			height: 4px;
			background: #12b1f9;
			margin: 20px 0px;
		}
	}
	.nologoheader {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 20px;
		color: #102d4d;
		letter-spacing: 1.5px;
		font-weight: bold;
		position: relative;
		margin-top: 21px;
		.blueline {
			width: 44px;
			height: 4px;
			background: #12b1f9;
			margin: 20px 0px;
		}
	}
}
@media screen and (min-width: 600px) {
	.three_box_item {
		width: 33%;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 90%;
			object-fit: cover;
		}
	}
}
@media screen and (max-width: 599px) and (min-width: 400px) {
	.three_box_item {
		width: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 100%;
			object-fit: cover;
		}
	}
	.three {
		margin-top: -60px;
	}
}
@media screen and (max-width: 400px) {
	.three_box_item {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 100%;
			object-fit: cover;
		}
	}
	.two {
		margin-top: -80px;
	}
	.three {
		margin-top: -80px;
	}
}
@media screen and (min-width: 800px) {
	.about_one {
		width: 100vw;
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #eef6fa;
		position: relative;
		.content_box {
			display: flex;
			align-items: flex-start;
			max-width: 956px;
			padding: 20px 100px;
			position: relative;
			.content_one {
				max-width: 285px;
				position: relative;
				z-index: 2;
				.leftIcon {
					position: absolute;
					top: 50%;
					left: 10px;
					z-index: 10;
					cursor: pointer;
				}
				.rightIcon {
					position: absolute;
					top: 50%;
					right: 10px;
					z-index: 10;
					cursor: pointer;
				}
			}
			.content_two {
				margin-top: 39px;
				z-index: 2;
				.title {
					font-weight: bold;
					font-size: 22px;
					color: black;
					margin-left: 9px;
				}
				.dis {
					font-size: 14px;
					line-height: 1.5;
					letter-spacing: 1.5px;
					color: rgba(0, 0, 0, 0.7);
					margin-left: 9px;
				}
				.downloadbox {
					padding-left: 9px;
					display: flex;
					margin-top: 57px;
					align-items: center;
					.downloadleft_box {
						margin-top: 20px;
						font-size: 14px;
						color: rgba(18, 177, 249, 1);
						font-weight: 400;
						border: 1px solid rgba(18, 177, 249, 1);
						cursor: pointer;
						text-align: center;
						border-radius: 8px;
						padding: 15px 40px;
						transition: 0.3s;
					}
					.downloadleft_box:hover {
						background: #2188ca;
						color: white;
					}
					.downloadleft {
						margin-left: 44px;
					}
					.downloadright {
						img {
							width: 30vw;
							max-width: 260px;
						}
					}
				}
			}
			.borderWhitebox {
				position: absolute;
				border: 1px solid rgba(255, 255, 255, 1);
				border-radius: 12px;
				height: 340px;
				width: 82%;
				bottom: 90px;
				z-index: 1;
				background: rgba(255, 255, 255, 0.2);
			}
		}
		.backgroundI {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
	}
}
@media screen and (max-width: 799px) {
	.about_one {
		width: 100vw;
		display: flex;
		flex-direction: column;
		align-items: center;
		background: rgba(238, 244, 255, 1);
		position: relative;
		.content_box {
			max-width: 1087px;
			padding: 20px 100px;
			display: flex;
			flex-direction: column;
			align-items: center;
			position: relative;
			.content_one {
				width: 100%;
				max-width: 387px;
				position: relative;
				z-index: 2;
				.leftIcon {
					position: absolute;
					top: 48%;
					left: 10px;
					z-index: 10;
					cursor: pointer;
				}
				.rightIcon {
					position: absolute;
					top: 48%;
					right: 10px;
					z-index: 10;
					cursor: pointer;
				}
			}
			.content_two {
				z-index: 2;
				.title {
					font-weight: bold;
					font-size: 22px;
					color: black;
				}
				.dis {
					font-size: 14px;
					line-height: 1.5;
					letter-spacing: 1.5px;
					color: rgba(0, 0, 0, 0.7);
					margin-top: 20px;
				}
				.downloadbox {
					display: flex;
					margin-top: 57px;
					align-items: center;
					.downloadleft_box {
						margin-top: 20px;
						font-size: 14px;
						color: rgba(18, 177, 249, 1);
						font-weight: 400;
						border: 1px solid rgba(18, 177, 249, 1);
						cursor: pointer;
						text-align: center;
						border-radius: 8px;
						padding: 15px 0px;
						transition: 0.3s;
						width: 36vw;
						min-width: 140px;
					}
					.downloadleft_box:hover {
						background: #2188ca;
						color: white;
					}
					.downloadleft {
						margin-left: 20px;
					}
					.downloadright {
						img {
							width: 30vw;
							min-width: 180px;
							max-width: 260px;
						}
					}
				}
			}
		}
		.backgroundI {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
}
</style>
